/*
 * Pre-Cart Upsell (Phase 2) - Namespace: pcu
 * Runde 34 (Cutover, 2026-09-17): Preview-Gate entfernt - laeuft jetzt fuer ALLE Besucher aktiv.
 * proceedToRealCart() oeffnet ab jetzt primaer den neuen nativen Side Cart (window.CSC_CART),
 * AMPs eigener Cart (realOpenHolder.fn, frueher der Normalfall) ist nur noch Sicherheitsnetz,
 * falls CSC_CART aus irgendeinem Grund nicht verfuegbar ist (z.B. Script-Ladefehler).
 *
 * Runde 38 (2026-09-23, Christian-Wunsch, Starter-Sets ueberarbeitet): kompletter Content-Umbau
 * dieser Seite - bisher warb dieser Drawer nach dem ERSTEN Geraete-Add fuer das Jahresvorrat-
 * Pad-Abo (ein einzelnes Produkt, "Jahresabo"-Copy, Selling-Plan-Erkennung). Das faellt komplett
 * weg. Stattdessen jetzt (wie wearewild-Referenz, aber ohne Minis/Bars-Auswahl-Tabs): ein Grid
 * aus Probierpackungen (dieselben 5 Minis wie im Cart-Upsell, siehe MINI_PRODUCTS in
 * cart-drawer-v2.js - Beauty-Mix/Energiegruen-Mix/Rucola/Radieschen-Mix/Balance-Mix), reiner
 * Einzelkauf (kein Abo-Toggle mehr), % Angebot-Badge nur auf Basis des vorhandenen Streichpreises
 * (kein neuer Rabattcode - Christian-Entscheidung), PLUS eine Progress-Bar fuer das neue,
 * vereinfachte Mystery-Pack-Ziel (Single ab 160€ / Duo ab 210€, ersetzt die alte 130/170/200€-
 * Leiter - siehe cart-drawer-v2.js Runde 38 fuer die Cart-seitige Haelfte derselben Aenderung).
 * Die eigentliche Mystery-Pack-Beanspruchung ("+"-Klick) passiert weiterhin nur im Cart-Drawer
 * (bestehende "🎁 Gratis Goodies"-Karte, unveraendert) - diese Seite zeigt den Fortschritt nur an.
 *
 * Zweck (unveraendert): nach dem ERSTEN Hinzufuegen eines Geraete-Produkts (Kennenlern-Set/
 * Starter-Kit/Duo, ueber egal welchen der drei Add-to-Cart-Flows: kennenlern-offer.liquid,
 * gallery-v3.liquid, product-form-starter-kit.js) einmalig pro Cart-Session einen Upsell-Drawer
 * zeigen, BEVOR sich der Cart-Drawer oeffnet. Skip oder ein Produkt-Add fuehren danach direkt zum
 * Oeffnen des nativen Side Carts weiter (Grid-Adds schliessen den Drawer NICHT automatisch -
 * Kunde kann mehrere Minis nacheinander hinzufuegen, bevor er weiter zum Cart geht).
 *
 * Technischer Ansatz (unveraendert, keine Aenderung an den drei geteilten PDP-Dateien noetig):
 * alle drei Flows rufen nach erfolgreichem /cart/add.js ausschliesslich `window.SLIDECART_UPDATE()`
 * und anschliessend `window.SLIDECART_OPEN()` auf (AMPs eigene, zur Laufzeit von der App
 * injizierte globale Hooks - kein Theme-Code, daher nicht direkt editierbar). Wir ueberschreiben
 * `window.SLIDECART_OPEN` per Object.defineProperty als Accessor (nicht per einfacher
 * Zuweisung!), weil AMPs Script wegen des Lazy-Load-Mechanismus in layout/theme.liquid
 * (content_for_header nur nach einem mbc_load-Event) seine eigene Zuweisung unter Umstaenden
 * ERST NACH diesem Script vornimmt - ein Accessor faengt sowohl den Lesezugriff der PDP-Flows
 * als auch eine spaetere Zuweisung durch AMP zuverlaessig ab, unabhaengig von der Ladereihenfolge.
 *
 * Bekannte Luecke: sections/vorverkauf-duo-offer.liquid (Duo-Vorverkaufs-Landingpage) ruft
 * SLIDECART_OPEN gar nicht auf, sondern leitet nach Add-to-Cart direkt zu /checkout bzw. /cart
 * weiter - dieser eine Flow wird vom Pre-Cart-Upsell bewusst nicht abgefangen (eigener,
 * separater Eingriff noetig, falls das gewuenscht ist).
 */
(function () {
  'use strict';

  var SHOWN_KEY = 'pcu_shown';

  // Runde 46 (2026-10-05, Christian): Presell-Seite fuer einen 14-Tage-Test AUSGESCHALTET.
  // false = nach "In den Warenkorb" oeffnet direkt der Cart (Probierpackungen gibt es dort in der
  // Upsell-Leiste). Zum Wiedereinschalten einfach auf true setzen - sonst keine Aenderung noetig.
  var PCU_ENABLED = false;

  // Dieselben 5 Probierpackungen wie MINI_PRODUCTS in cart-drawer-v2.js (Runde 17) - bewusst
  // identische Liste/Reihenfolge, damit diese Seite und der Cart-Upsell konsistent wirken. Bild/
  // Preis/Streichpreis kommen live aus /products/{handle}.js, damit Preisaenderungen im Shopify
  // Admin ohne Code-Redeploy greifen (gleiches Prinzip wie im Rest des Projekts).
  var PCU_MINI_PRODUCTS = [
    { handle: 'beauty-booster-3-pads', title: 'Beauty-Mix', variety: 'Senf · Rotkohl · Rucola' },
    { handle: 'cardio-health-booster-3-pads', title: 'Energiegrün-Mix', variety: 'Radieschen · Senf · Rucola' },
    { handle: 'rucola-probierpackung', title: 'Rucola', variety: '3x Rucola' },
    { handle: 'radieschen-mix-probierpackung', title: 'Radieschen-Mix', variety: '3x Radieschen Mix' },
    { handle: 'balance-probierpackung-3-pads', title: 'Balance-Mix', variety: '2x Senf · Rotkohl' },
  ];

  // Mystery-Pack-Progress-Ziel (Runde 38) - identisch zur Cart-Drawer-Logik (cart-drawer-v2.js
  // progressTiers(true, isDuo)), hier bewusst separat gehalten statt importiert, da beide Dateien
  // eigenstaendig sind (Projekt-Konvention: kein globaler Cross-File-State). Aenderungen an
  // Betrag/Produkt hier IMMER synchron mit cart-drawer-v2.js nachziehen.
  var MYSTERY_PACK = {
    handle: 'bio-mystery-pack',
    amountSingle: 16000,
    amountDuo: 21000,
  };

  var drawerEl = document.getElementById('pcu-drawer');
  var bodyEl = document.getElementById('pcu-body');
  var footerBtn = document.getElementById('pcu-skip');
  if (!drawerEl || !bodyEl || !footerBtn) return;

  drawerEl.querySelectorAll('[data-pcu-close]').forEach(function (el) {
    if (el === footerBtn) return; // footerBtn bekommt weiter unten einen eigenen Handler
    el.addEventListener('click', function () {
      advanceToRealCart();
    });
  });

  function moneyFormat(cents) {
    var value = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return '€' + value;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  var productCache = {};
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject(new Error('product fetch failed'));
      })
      .then(function (data) {
        productCache[handle] = data;
        return data;
      })
      .catch(function () {
        return null; // einzelne fehlende Produkte sollen das restliche Grid nicht blockieren
      });
  }

  function openDrawer() {
    // Ans Ende von <body> haengen, bevor wir oeffnen: AMPs Slide-Cart liegt auf demselben
    // Max-z-Index (siehe pre-cart-upsell.css) - bei gleichem z-index gewinnt die spaetere
    // DOM-Position. Falls der echte Cart schon offen ist (z.B. manuell vom Nutzer geoeffnet),
    // soll unser Upsell trotzdem sichtbar obenauf liegen.
    document.body.appendChild(drawerEl);
    drawerEl.classList.add('is-active');
    // Reflow erzwingen, bevor is-visible gesetzt wird, damit die CSS-Transition (transform/
    // opacity) tatsaechlich abspielt statt sofort im Endzustand zu starten - gleiches Muster
    // wie beim Custom Side Cart (cart-drawer-v2.js open()).
    void drawerEl.offsetHeight;
    requestAnimationFrame(function () {
      drawerEl.classList.add('is-visible');
    });
    document.body.classList.add('scroll-lock-mobile');
  }

  function closeDrawer() {
    drawerEl.classList.remove('is-visible');
    document.body.classList.remove('scroll-lock-mobile');
    setTimeout(function () {
      drawerEl.classList.remove('is-active');
    }, 350);
  }

  // ---- Progress-Bar (Runde 38) - identische Stepper-Optik wie cart-drawer-v2.js progressMarkup(),
  // aber bewusst eigenstaendig unter dem pcu-Namespace nachgebaut (keine Abhaengigkeit zwischen
  // den beiden Dateien) und auf EINEN Meilenstein reduziert (kein generisches Tier-Array noetig). ----
  function progressBarMarkup(subtotalCents, threshold) {
    var done = subtotalCents >= threshold;
    var fillPct = done ? 100 : Math.max(0, Math.min(1, subtotalCents / threshold)) * 100;
    var headline = done
      ? '🎉 Mystery Pack freigeschaltet - im Warenkorb beanspruchen!'
      : 'Noch ' + moneyFormat(threshold - subtotalCents) + ' bis <strong>Mystery Pack gratis</strong>';
    // Runde 41 (2026-09-23, Christian-Feedback, siehe cart-drawer-v2.js progressMarkup() fuer den
    // ausfuehrlichen Kommentar/Kontext): "Du bist hier"-Marker genau am Fuellstand + staerkerer
    // Track-Kontrast (siehe CSS), damit eine kleine Restdistanz bei hohem Fuellstand nicht optisch
    // wie "schon da" wirkt.
    var markerHtml = !done
      ? '<div class="pcu-progress__marker" style="left: calc(10px + ' + fillPct + '%)"></div>'
      : '';
    return (
      '<div class="pcu-progress">' +
      '<div class="pcu-progress__headline">' + headline + '</div>' +
      '<div class="pcu-progress__stepper">' +
      '<div class="pcu-progress__line"></div>' +
      '<div class="pcu-progress__line-fill" style="width: ' + fillPct + '%"></div>' +
      markerHtml +
      '<div class="pcu-progress__point pcu-progress__point--start is-done">' +
      '<span class="pcu-progress__dot">✓</span>' +
      '</div>' +
      '<div class="pcu-progress__point pcu-progress__point--end' + (done ? ' is-done' : '') + '">' +
      '<span class="pcu-progress__dot">' + (done ? '✓' : '') + '</span>' +
      '<span class="pcu-progress__point-label"><strong>Mystery Pack</strong><span>Ab ' + moneyFormat(threshold) + '</span></span>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  // ---- Produkt-Grid ------------------------------------------------------------------------
  function miniCardMarkup(entry, product) {
    if (!product) return '';
    var variant = product.variants && product.variants[0];
    if (!variant) return '';
    // Runde 40 (2026-09-23, Christian-Wunsch): oversold/ausverkaufte Varianten (variant.available
    // kommt frisch von /products/{handle}.js bei jedem Drawer-Open, siehe fetchProduct oben) werden
    // nicht mehr als Karte angezeigt - verschwinden/erscheinen automatisch mit dem Lagerbestand, kein
    // manuelles Rausnehmen aus PCU_MINI_PRODUCTS noetig. Gleiche Logik wie in cart-drawer-v2.js
    // (Runde 40) - Ausloeser: Beauty-Mix Probierpackung war oversold (inventoryPolicy DENY).
    if (variant.available === false) return '';
    var price = variant.price;
    var compareAt = variant.compare_at_price ? parseInt(variant.compare_at_price, 10) : 0;
    var hasOffer = compareAt > price;
    var pctOff = hasOffer ? Math.round((1 - price / compareAt) * 100) : 0;
    var imgSrc = product.featured_image || (variant.featured_image && variant.featured_image.src) || '';

    return (
      '<div class="pcu-mini-card">' +
      '<div class="pcu-mini-card__image">' +
      (hasOffer ? '<span class="pcu-mini-card__badge">-' + pctOff + '%</span>' : '') +
      (imgSrc ? '<img src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(entry.title) + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="pcu-mini-card__body">' +
      '<div class="pcu-mini-card__title">' + escapeHtml(entry.title) + '</div>' +
      '<div class="pcu-mini-card__variety">' + escapeHtml(entry.variety) + '</div>' +
      '<div class="pcu-mini-card__price-row">' +
      (hasOffer ? '<span class="pcu-price--was">' + moneyFormat(compareAt) + '</span>' : '') +
      '<span class="pcu-price">' + moneyFormat(price) + '</span>' +
      '</div>' +
      '<button type="button" class="pcu-mini-card__add" data-pcu-add data-variant-id="' + variant.id + '">Hinzufügen</button>' +
      '</div>' +
      '</div>'
    );
  }

  var currentDeviceType = null;
  var addedCount = 0;

  function updateFooterButton() {
    footerBtn.textContent = addedCount > 0 ? 'Weiter zum Warenkorb' : 'Nein, danke';
  }

  function renderProgress(subtotalCents) {
    var threshold = currentDeviceType === 'duo' ? MYSTERY_PACK.amountDuo : MYSTERY_PACK.amountSingle;
    // Runde 39: Progress-Bar liegt nicht mehr im scrollbaren #pcu-body, sondern in einem eigenen
    // Container zwischen Body und Footer (#pcu-progress-sticky, siehe pre-cart-upsell.liquid) - so
    // bleibt sie beim Scrollen durchs Minis-Grid immer sichtbar, analog zur fixen Bottom-Bar im
    // wearewild-Referenz-Screenshot (Christian-Feedback 2026-09-23).
    var el = document.getElementById('pcu-progress-sticky');
    if (el) el.innerHTML = progressBarMarkup(subtotalCents, threshold);
  }

  function showUpsell(deviceType) {
    currentDeviceType = deviceType;
    addedCount = 0;
    updateFooterButton();
    openDrawer();

    bodyEl.innerHTML =
      '<h3 class="pcu-headline">Probiere unsere Probierpackungen</h3>' +
      '<p class="pcu-subline">Bio-Probierpackungen zum Kennenlernen neuer Sorten.</p>' +
      '<div class="pcu-minis-grid" id="pcu-minis-grid"></div>';

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderProgress(cart.items_subtotal_price);
      })
      .catch(function () {});

    Promise.all(PCU_MINI_PRODUCTS.map(function (entry) {
      return fetchProduct(entry.handle).then(function (product) {
        return { entry: entry, product: product };
      });
    })).then(function (results) {
      var gridEl = document.getElementById('pcu-minis-grid');
      if (!gridEl) return;
      gridEl.innerHTML = results.map(function (r) {
        return miniCardMarkup(r.entry, r.product);
      }).join('');
    });
  }

  bodyEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pcu-add]');
    if (!btn) return;
    btn.disabled = true;
    var originalLabel = btn.textContent;
    btn.textContent = 'Wird hinzugefügt …';
    var variantId = Number(btn.getAttribute('data-variant-id'));
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        return res.ok ? res.json() : Promise.reject(new Error('cart add failed'));
      })
      .then(function () {
        addedCount += 1;
        updateFooterButton();
        btn.textContent = 'Hinzugefügt ✓';
        return fetch('/cart.js').then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        renderProgress(cart.items_subtotal_price);
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = originalLabel;
        }, 1500);
      })
      .catch(function (err) {
        console.error('[pcu] Mini konnte nicht hinzugefuegt werden:', err);
        btn.disabled = false;
        btn.textContent = originalLabel;
      });
  });

  footerBtn.addEventListener('click', function () {
    advanceToRealCart();
  });

  // --- Erkennung: was wurde gerade hinzugefuegt? ---
  // Runde 32 (Root-Cause-Fix): urspruenglich haben wir die Response von POST /cart/add.js selbst
  // abgefangen (per fetch()-Wrapper) und item.product_type / item.handle daraus gelesen. Live-Test
  // hat gezeigt: die /cart/add.js-Response von Shopify enthaelt WEDER product_type NOCH handle auf
  // den Line-Items (nur /cart.js, die volle Warenkorb-Ansicht, liefert diese Felder vollstaendig) -
  // deshalb hat detectDeviceType() bisher IMMER null zurueckgegeben und der Upsell ist nie
  // erschienen, unabhaengig von Geraet/Flow. Fix: statt die add.js-Response mitzulesen, holen wir
  // beim SLIDECART_OPEN-Aufruf direkt frisch /cart.js (enthaelt garantiert alle Felder) und werten
  // deren items aus. Kein Race mit den drei PDP-Flows mehr moeglich, da wir zum Zeitpunkt des
  // tatsaechlichen Aufrufs lesen statt eine frueher zwischengespeicherte, unvollstaendige Response.
  // Runde 42 (2026-09-23, Christian-Report: Presell kam bei "Gesundes Altern Set duo" - Flexplan/
  // VAT-Split-Produkt - nicht, live auf Mobile/Firefox verifiziert): urspruengliche Erkennung
  // verliess sich ausschliesslich auf item.product_type === 'Growing Kit'. Flexplan-Produkte
  // splitten sich aber in ZWEI Line-Items (Pad-Bundle + separates Hardware-Item), von denen KEINS
  // product_type "Growing Kit" traegt (Pad-Item = "Seed pads", Hardware-Item = leer) - Treffer war
  // dadurch nie moeglich, SLIDECART_OPEN feuerte zwar korrekt, aber detectDeviceType() gab immer
  // null zurueck. Fix: zusaetzlich dieselben Bundle-Properties pruefen, die cart-drawer-v2.js's
  // isNeukundeCart() bereits fuer genau diesen Zweck nutzt (bundle_root/_bundle/baseVariant -
  // Flexplan setzt bundle_root='StarterSet' auf dem Pad-Item, siehe
  // product-form-starter-kit-flexplan.js addProductsToCart(), per Subagent verifiziert).
  // product_type-Check bleibt zusaetzlich bestehen (Abwaertskompatibilitaet zu den drei aelteren
  // PDP-Flows: kennenlern-offer.liquid/gallery-v3.liquid/product-form-starter-kit.js).
  function isDeviceLikeItem(item) {
    var props = item.properties || {};
    return item.product_type === 'Growing Kit' || !!props.bundle_root || !!props._bundle || !!props.baseVariant;
  }

  function isDuoDevice(item) {
    var handle = (item.handle || '').toLowerCase();
    var title = (item.product_title || '').toLowerCase();
    return isDeviceLikeItem(item) && (handle.indexOf('duo') !== -1 || title.indexOf('duo') !== -1);
  }

  function isSingleDevice(item) {
    return isDeviceLikeItem(item) && !isDuoDevice(item);
  }

  function detectDeviceType(items) {
    if (!items) return null;
    var i;
    for (i = 0; i < items.length; i++) {
      if (isDuoDevice(items[i])) return 'duo';
    }
    for (i = 0; i < items.length; i++) {
      if (isSingleDevice(items[i])) return 'single';
    }
    return null;
  }

  // --- SLIDECART_OPEN abfangen ---
  var realOpenHolder = { fn: null };

  // Runde 34 (Cutover): oeffnet primaer den neuen nativen Side Cart (frisch gerendert, damit ein
  // gerade hinzugefuegtes Produkt sofort sichtbar ist - CSC_CART.refresh ist cart-drawer-v2.js'
  // render()). AMPs Original-Cart (realOpenHolder.fn) ist nur noch Sicherheitsnetz fuer den Fall,
  // dass CSC_CART aus irgendeinem Grund nicht verfuegbar ist (z.B. Script noch nicht geladen) -
  // damit der Kunde in jedem Fall IRGENDEINEN Cart sieht statt gar keine Reaktion.
  // Runde 44 (2026-09-23, Christian-Feedback: "PDP blitzt kurz auf, dann kommt der Side Cart erst
  // mit einem Versatz - sollte viel smoother gehen, man sollte die PDP gar nicht mehr sehen"):
  // vorher wurde refresh() ABGEWARTET, bevor open() ueberhaupt aufgerufen wurde. render() (=
  // CSC_CART.refresh) macht mehrere sequentielle Fetches (Cart neu laden, Bundle-Cleanup, Gift-/
  // Discount-Sync, Compare-at-Preise pro Zeile, Abo-Ersparnis-Lookup - siehe cart-drawer-v2.js
  // render()) und kann dadurch je nach Verbindung deutlich laenger dauern als die 350ms-
  // Ausblendanimation des Presell-Drawers (closeDrawer() oben). In der Luecke dazwischen war die
  // PDP kurz sichtbar, bevor der echte Cart (mit eigener 350ms-Slide-in-Animation) endlich
  // erschien - daher der spuerbare Versatz/Doppel-Delay.
  // Fix: open() sofort SYNCHRON aufrufen, nicht erst nach refresh(). render() laeuft bereits einmal
  // beim initialen Scriptstart (siehe render()-Aufruf am Dateiende von cart-drawer-v2.js) und bei
  // jeder Cart-Aenderung seither, das Drawer-Markup ist also nie leer - open() zeigt sofort den
  // zuletzt bekannten Cart-Stand an und gleitet direkt rein, waehrend der Presell-Drawer parallel
  // rausgleitet (keine Luecke mehr = keine sichtbare PDP dazwischen). refresh() aktualisiert den
  // Inhalt (den gerade im Presell-Drawer hinzugefuegten Mini etc.) im Hintergrund, waehrend/nachdem
  // der Cart bereits sichtbar ist - kein Warten mehr noetig.
  function proceedToRealCart() {
    if (window.CSC_CART && typeof window.CSC_CART.open === 'function') {
      window.CSC_CART.open();
      window.CSC_CART.refresh().catch(function () {});
      return;
    }
    if (typeof realOpenHolder.fn === 'function') {
      realOpenHolder.fn();
      return;
    }
  }

  // Runde 45 (2026-09-23, Christian-Feedback per Screen-Recording: Uebergang Presell->Cart weiterhin
  // "ruckelig auf champions-league-niveau bringen", zusaetzlich "man sieht den Cart erst leer, dauert
  // zu lange bis das Produkt drin ist"): Frame-genaue Video-Analyse (20fps-Ausschnitt der Klick-
  // Sekunde) zeigt in der Luecke zwischen Presell-Skip-Klick und fertigem Cart zwei Symptome:
  // (1) ein kurzes PDP-Aufblitzen im Umschaltmoment, (2) danach zeigt der bereits (Runde 44) offene
  // Cart-Drawer fuer ca. 0,9-1s "Dein Warenkorb ist leer" - der zuletzt bekannte DOM-Stand aus dem
  // initialen render()-Aufruf bei Scriptstart, BEVOR refresh() den tatsaechlichen Inhalt (2 Artikel)
  // nachliefert. Ursache: der Runde-44-Fix rief open() bewusst synchron VOR refresh() auf, um die
  // vorherige Luecke (PDP kurz sichtbar) zu schliessen - das macht dabei aber den noch nicht
  // aktualisierten, alten Cart-Stand selbst sichtbar, waehrend refresh() (mehrere sequentielle
  // Fetches, siehe cart-drawer-v2.js render()) erst im Hintergrund laeuft.
  // Fix: den echten Cart bereits OEFFNEN, WAEHREND der Presell-Drawer noch vollstaendig sichtbar ist -
  // er haengt per openDrawer() immer am Ende von <body> und liegt dadurch bei identischem z-index
  // ueber dem echten Cart (siehe pre-cart-upsell.css) -, open()+refresh() laufen also unsichtbar
  // dahinter ab. Erst wenn refresh() fertig ist (oder ein Sicherheits-Timeout von 900ms erreicht ist,
  // je nachdem was zuerst eintritt - die Video-Messung ergab ca. 950ms fuer den vollen refresh()-
  // Zyklus, 900ms ist bewusst knapp darunter als Kompromiss zwischen "meistens fertig" und "fuehlt
  // sich nie haengend an") wird der Presell-Drawer geschlossen (closeDrawer()) und gibt den Blick auf
  // einen bereits fertig geladenen, bereits eingeblendeten echten Cart frei - kein PDP-Blitzen, kein
  // Leer-Zustand mehr sichtbar, EIN durchgehender Uebergang statt drei sichtbaren Zwischenschritten.
  // Waehrend der kurzen Wartezeit sichert die is-advancing-Klasse (siehe CSS) gegen Doppelklicks ab
  // und dimmt den Skip-Button leicht, damit der Klick trotzdem spuerbar reagiert.
  // Ersetzt fuer den Skip-/Schliessen-Fall (footerBtn + [data-pcu-close]) das bisherige
  // "closeDrawer(); proceedToRealCart();"-Paar. proceedToRealCart() selbst bleibt unveraendert und
  // wird weiterhin dort verwendet, wo gar kein Presell-Drawer sichtbar ist (bereits gezeigter Upsell,
  // direkter Cart-Icon-Klick, /cart.js-Fetch-Fehler) - dort gibt es nichts zu verstecken/aufzudecken.
  var isAdvancing = false;

  function withTimeout(promise, ms) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve();
      }, ms);
      promise.then(function () {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve();
      });
    });
  }

  function advanceToRealCart() {
    if (isAdvancing) return;
    isAdvancing = true;
    drawerEl.classList.add('is-advancing');

    function reveal() {
      closeDrawer();
      drawerEl.classList.remove('is-advancing');
      isAdvancing = false;
    }

    if (window.CSC_CART && typeof window.CSC_CART.open === 'function') {
      window.CSC_CART.open();
      var refreshDone = window.CSC_CART.refresh().catch(function () {});
      withTimeout(refreshDone, 900).then(reveal);
      return;
    }

    // Kein CSC_CART verfuegbar (Sicherheitsnetz, z.B. Script noch nicht geladen): nichts zu verbergen,
    // altes Verhalten - sofort schliessen und AMPs eigenen Cart oeffnen.
    reveal();
    if (typeof realOpenHolder.fn === 'function') {
      realOpenHolder.fn();
    }
  }

  try {
    Object.defineProperty(window, 'SLIDECART_OPEN', {
      configurable: true,
      get: function () {
        return function () {
          if (!PCU_ENABLED) {
            proceedToRealCart();
            return;
          }
          var alreadyShown = sessionStorage.getItem(SHOWN_KEY) === '1';
          if (alreadyShown) {
            console.log('[pcu] SLIDECART_OPEN abgefangen, bereits einmal gezeigt - direkt zum echten Cart.');
            proceedToRealCart();
            return;
          }
          // Runde 32: /cart.js frisch holen statt auf die (unvollstaendige) /cart/add.js-Response
          // von vorhin zu vertrauen - siehe Kommentar bei detectDeviceType oben.
          fetch('/cart.js')
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              var items = cart && cart.items;
              var deviceType = detectDeviceType(items);
              console.log('[pcu] SLIDECART_OPEN abgefangen. /cart.js items=', items, 'deviceType=', deviceType);
              if (deviceType) {
                sessionStorage.setItem(SHOWN_KEY, '1');
                showUpsell(deviceType);
                return;
              }
              proceedToRealCart();
            })
            .catch(function (err) {
              console.error('[pcu] /cart.js-Fetch fehlgeschlagen, Fallback auf echten Cart:', err);
              proceedToRealCart();
            });
        };
      },
      set: function (fn) {
        realOpenHolder.fn = fn;
      }
    });
  } catch (e) {
    // Sollte laut Recherche nicht vorkommen (Property ist per einfacher Zuweisung immer
    // configurable) - stiller Fallback: Pre-Cart-Upsell greift dann einfach nicht, normales
    // Verhalten (echter SLIDECART_OPEN) bleibt unangetastet.
  }

  // Runde 35 (Cutover Teil 2, 2026-09-18): Ein direkter Klick auf das Cart-Icon im Header
  // (data-slidecart-trigger) laeuft NICHT ueber window.SLIDECART_OPEN - AMP oeffnet seinen
  // eigenen Cart (#slidecarthq) darueber komplett eigenstaendig, die Abfang-Logik oben greift
  // hier nicht. Von Christian live bestaetigt (2026-09-18): Klick aufs Cart-Icon zeigte weiterhin
  // AMPs alten Cart statt des neuen, unabhaengig vom Warenkorb-Inhalt.
  // Fix: eigener Klick-Handler in der CAPTURE-Phase auf document. Capture-Listener auf einem
  // Vorfahren (document) feuern laut Event-Spezifikation IMMER komplett VOR jeglichem Listener
  // auf dem Zielelement selbst (Target-/Bubble-Phase) - unabhaengig davon, ob AMP seinen eigenen
  // Handler per Bubble-Delegation auf document oder direkt aufs Element gelegt hat. So wird AMPs
  // eigener Trigger nie erreicht, solange wir preventDefault + stopImmediatePropagation aufrufen.
  // Kein Upsell-Check hier (SHOWN_KEY/detectDeviceType) - der Upsell ist nur fuer den direkten
  // Post-Add-to-Cart-Flow gedacht, ein blosser Cart-Icon-Klick geht direkt zum echten Cart.
  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('[data-slidecart-trigger]') : null;
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    proceedToRealCart();
  }, true);
})();